const name = 'circle-z';

const contents = '<path fill="#FFF" d="M41.564 55H20.436v-3.729l10.688-15.66 3.563-4.142v-.415l-4.971.415h-8.452v-4.64h19.72v3.811L30.461 46.217l-3.562 4.143v.414l4.888-.414h9.777z"/>';

/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'Z',
};

export default icon;
